import { render } from "./SocialLogin.vue?vue&type=template&id=6dd4e4db&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"

import "./SocialLogin.vue?vue&type=style&index=0&id=6dd4e4db&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd4e4db"]])

export default __exports__